import { ISiteNotification } from '@libs/interfaces';
import { createAction, props } from '@ngrx/store';
import { ISiteNotificationFilters } from './model';

const AddNotifications = '[Notifications] Add notifications'
export const addNotifications = createAction(
  AddNotifications,
  props<{ notifications: ISiteNotification[] }>()
);
const AddNotification = '[Notifications] Add notification'
export const addNotification = createAction(
  AddNotification,
  props<{ notification: ISiteNotification }>()
);
const SetReadNotification = '[Notifications] Set read notification'
export const setReadNotification = createAction(
  SetReadNotification,
  props<{ notification: ISiteNotification }>()
);
const SetFiltersNotification = '[Notifications] Set filters notification'
export const setFiltersNotification = createAction(
  SetFiltersNotification,
  props<{ filters: ISiteNotificationFilters }>()
);

